module.exports = __webpack_public_path__ + "static/media/6-months-CN.e6c73956.png";